<template>
  <div class="frame17_body">
    <div class="frame17">
      <div class="frame17_top">
        投资评级
        <img
          src="../../../../public/img/shares_Info/close.png"
          alt=""
          @click="frame17_close"
        />
      </div>
      <div class="frame17_content">
        <div class="frame17_content_title">投资评级</div>
        <div class="frame17_content_text">
          【释义】：对最近90天来自个机构的投资评级进行1-5标准化，给予最高1分最低5分的标准分值，1分相当于买入、2分相当于增持、3分相当于中性、4分相当于减持、5分相当于卖出，并根据这一评级进进一步细分。
        </div>
        <div class="frame17_content_text">【算法】： [1.00,1.25):买入 [1.25,1.50):买入- [1.50,1.75):增持+ [1.75,2.25):增持 [2.25,2.50):增持- [2.50,2.75):中性+ [2.75,3.25):中性 [3.25,3.50):中性- [3.50,3.75):减持+ [3.75,4.25):减持 [4.25,4.50):减持- [4.50,4.75):卖出+ [4.75,5.00):卖出 </div>
        <div class="frame17_content_text">【单位】：-</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    frame17_close() {
      this.$emit("frame17_close");
    },
  },
};
</script>

<style scoped>
.frame17_body {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  z-index: 9999999;
}
.frame17 {
  width: 448px;
  height: 420px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 36px;
  margin: 50px auto;
  margin-top: 200px;
}
.frame17_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame17_content {
  margin-top: 28px;
}
.frame17_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame17_content_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.frame17_content_text {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
</style>